import { z } from 'zod';
import { isoDateStringSchema, uuidSchema } from './common';

export const projectStepSchema = z.object({
  id: uuidSchema,
  title: z.string().min(1).max(200),
  position: z.number().int().nonnegative(),
  estDurationMin: z.number().int().positive().nullable().optional(),
});
export type ProjectStep = z.infer<typeof projectStepSchema>;

export const projectSchema = z.object({
  id: uuidSchema,
  title: z.string(),
  steps: z.array(projectStepSchema),
  archivedAt: isoDateStringSchema.nullable(),
  createdAt: isoDateStringSchema,
});
export type Project = z.infer<typeof projectSchema>;

export const createProjectStepRequestSchema = z.object({
  title: z.string().min(1).max(200),
  estDurationMin: z.number().int().positive().nullable().optional(),
});
export type CreateProjectStepRequest = z.infer<typeof createProjectStepRequestSchema>;

export const createProjectRequestSchema = z.object({
  title: z.string().min(1).max(200),
  steps: z.array(createProjectStepRequestSchema).min(1).max(50),
});
export type CreateProjectRequest = z.infer<typeof createProjectRequestSchema>;

export const updateProjectRequestSchema = z
  .object({
    title: z.string().min(1).max(200).optional(),
    archived: z.boolean().optional(),
  })
  .refine((v) => Object.values(v).some((x) => x !== undefined), {
    message: 'At least one field must be provided',
  });
export type UpdateProjectRequest = z.infer<typeof updateProjectRequestSchema>;
